<template>
    <div class="quantity">
        <button class="quantity__minus" @click.prevent="decrease">-</button>
        <input class="quantity__input" ref="val" type="number" @change.prevent="validateQuantity" v-bind:value="amount" min="1" max="500" step="1">
        <button class="quantity__plus" @click.prevent="increase">+</button>
    </div>
</template>

<script>
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";

export default {
    name  : "QuantityButtons",
    mixins: [errors, tools],
    data() {
        return {
            amount: 1
        }
    },
    methods: {
        increase() {
            if(this.amount > 499) return;
            this.amount++;
        },
        decrease() {
            if(this.amount < 2) return;
            this.amount--;
        },
        validateQuantity(event) {
            if(isNaN(parseInt(event.target.value)))
            {
                event.target.value = 1;
                return;
            }
            this.amount        = parseInt(event.target.value) > 0 && parseInt(event.target.value) <= 500 ? parseInt(event.target.value) : 1;
            event.target.value = this.amount;
        },
    },
}
</script>

<style scoped>

</style>